module.exports = __webpack_public_path__ + "media/images/emblems/Seewen-blason-b1ed283cda6515468ae02d2f1c077017.png";